import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './pages/Home';
import LoginModal from './modals/LoginModal';
import { Rules_EURO as RulesEuro } from './pages/Rules_EURO';
import { EntryFee } from './pages/user/EntryFee';
import { Contact } from './pages/Contact';
import { Ladder } from './pages/Ladder';
import RegistrationModal from './modals/RegistrationModal';
import CloseMatchModal from './modals/CloseMatchModal';
import { BonusTip } from './pages/user/BonusTip';
import { Gdpr } from './pages/Gdpr';
import { UserProfile } from './pages/user/UserProfile';
import AddMatchModal from './modals/AddMatchModal';
import { MyProfile } from './pages/user/MyProfile';
import { ForgotPassword } from './pages/ForgotPassword';
import { ResetPassword } from './pages/ResetPassword';
import { Admin } from './pages/Admin';
import { AdminImport } from './pages/AdminImport';
import { AdminSettings } from './pages/AdminSettings';
import { AdminTournaments } from './pages/AdminTournaments';
import IosAppPromoModal from './modals/IosAppPromoModal';
import { BottomNav } from './ui/layout/BottomNav';

function App() {
    return (
        <Router>
            <div className="min-h-screen bg-bg-app pb-[70px] sm:pb-0">
                <Routes>
                    <Route path="/"                              element={<Home />} />
                    <Route path="/zebricek"                      element={<Ladder />} />
                    <Route path="/pravidla"                      element={<RulesEuro />} />
                    <Route path="/gdpr"                          element={<Gdpr />} />
                    <Route path="/kontakt"                       element={<Contact />} />
                    <Route path="/forgot-password"               element={<ForgotPassword />} />
                    <Route path="/reset-password"                element={<ResetPassword />} />
                    <Route path="/admin"                         element={<Admin />} />
                    <Route path="/admin/tournaments"             element={<AdminTournaments />} />
                    <Route path="/admin/settings"                element={<AdminSettings />} />
                    <Route path="/admin/import"                  element={<AdminImport />} />
                    <Route path="/uzivatel/poplatek"             element={<EntryFee />} />
                    <Route path="/uzivatel/bonusova-otazka"      element={<BonusTip />} />
                    <Route path="/uzivatel/profil/muj-profil"    element={<MyProfile />} />
                    <Route path="/uzivatel/profil/:id"           element={<UserProfile />} />
                </Routes>

                {/* Global modals */}
                <CloseMatchModal />
                <AddMatchModal />
                <LoginModal />
                <RegistrationModal />
                <IosAppPromoModal />

                {/* Mobile bottom navigation */}
                <BottomNav />
            </div>
        </Router>
    );
}

export default App;
